import { Link } from 'react-router-dom'
import { icons } from '../Assets/Icons/icons'

export default function NotFoundPage() {
  return (
    <section className="not-found-container">
      <img src={icons.notFound} alt="Página não encontrada" />
      <h1>PÁGINA NÃO ENCONTRADA.</h1>
      <p>
        Ops! Não conseguimos encontrar a página que você procurou.{' '}
        <Link to={'/'}>Clique aqui para retornar</Link>
      </p>
    </section>
  )
}
